import { Badge } from '../ui/Badge';

/**
 * Statement-line status chip (Phase 1 reconciliation).
 *
 * Statuses (see plan §10):
 *   unmatched | suggested | matched | partially_matched |
 *   reconciled | ignored | duplicate | needs_review
 *
 * Also tolerates any string for forward-compat.
 */
const LABELS = {
  unmatched: 'Unmatched',
  suggested: 'Suggested',
  matched: 'Matched',
  partially_matched: 'Partially matched',
  reconciled: 'Reconciled',
  ignored: 'Ignored',
  duplicate: 'Duplicate',
  needs_review: 'Needs review',
};

const VARIANTS = {
  unmatched: 'neutral',
  suggested: 'warning',
  matched: 'default',
  partially_matched: 'warning',
  reconciled: 'success',
  ignored: 'neutral',
  duplicate: 'warning',
  needs_review: 'danger',
};

export function StatusChip({ status, className }) {
  const key = typeof status === 'string' ? status : 'unmatched';
  return (
    <Badge variant={VARIANTS[key] || 'neutral'} className={className}>
      {LABELS[key] || key}
    </Badge>
  );
}

export default StatusChip;
